module.exports = __webpack_public_path__ + "static/media/ArtDir-Audience.587213a9.jpg";